import React from "react";
import { Helmet } from "react-helmet"; // make sure you installed react-helmet-async
import "../styles/subpages.css";
import "../styles/common.css";

const Impresszum = () => {
  return (
    <section id="impresszum" className="subpage-section">
      <Helmet>
        <title>Impresszum – Olajcsere Szolnokon</title>
        <meta
          name="description"
          content="Az olajcsereszolnok.hu weboldal impresszuma. Ratkai Technologies Kft. hivatalos adatai, tárhelyszolgáltató és jogi nyilatkozatok."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://olajcsereszolnok.hu/impresszum" />

        {/* Open Graph for social sharing */}
        <meta property="og:title" content="Impresszum – Olajcsere Szolnokon" />
        <meta
          property="og:description"
          content="Ratkai Technologies Kft. hivatalos impresszum adatai, tárhelyszolgáltató és jogi nyilatkozatok."
        />
        <meta
          property="og:url"
          content="https://olajcsereszolnok.hu/impresszum"
        />
        <meta
          property="og:image"
          content="https://olajcsereszolnok.hu/og.png"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="container text-center d-flex flex-column align-items-center">
        <header className="subpage-header pt-5 mt-5">
          <h1>Impresszum</h1>
          <div className="divider mx-auto">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p className="subpage-intro">
            Jelen impresszum az olajcsereszolnok.hu weboldal üzemeltetőjének
            jogi adatait és az Eker. tv. 4. § szerinti kötelező tájékoztatást
            tartalmazza.
          </p>
        </header>

        <div className="subpage-card text-center">
          <h3>1. Szolgáltató adatai</h3>
          <p>
            <strong>Cégnév:</strong> Ratkai Technologies Kft. <br />
            <strong>Székhely:</strong> 5000 Szolnok, Rezeda utca 8.
            <br />
            <strong>Adószám:</strong> 24288503-2-16
            <br />
          </p>

          <h3>2. Tárhelyszolgáltató</h3>
          <p>
            <strong>Szolgáltató:</strong> Amazon Web Services (AWS) <br />
            <strong>Székhely:</strong> Seattle, WA, USA <br />
            <strong>Weboldal:</strong>{" "}
            <a href="https://aws.amazon.com" target="_blank" rel="noreferrer">
              https://aws.amazon.com
            </a>
          </p>

          <h3>3. Felelősség kizárása</h3>
          <p>
            A weboldalon található információk tájékoztató jellegűek. A
            szolgáltató nem vállal felelősséget az esetleges hibákért,
            elírásokért vagy a tartalom naprakészségéért.
          </p>

          <h3>4. Szerzői jog</h3>
          <p>
            A weboldal teljes tartalma (szövegek, képek, logók stb.) a
            szolgáltató tulajdonát képezi. Azok másolása, felhasználása vagy
            terjesztése kizárólag írásos engedéllyel lehetséges.
          </p>

          <h3>5. Jogviták</h3>
          <p>
            A weboldal használatával kapcsolatos vitás ügyekben a felek a
            Szolnoki Járásbíróság kizárólagos illetékességét kötik ki.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Impresszum;
